<template>
  <div class="row no-gutters catalog-numbers justify-content-end justify-content-sm-start mb-3 mb-sm-0">
    <div class="element-label">
      {{ I18n.t("search_page.artworks_tab.catalog_numbers_search.label") }}
    </div>
    <div>
      <input class="form-control" type="search"
             :placeholder="I18n.t('search_page.artworks_tab.catalog_numbers_search.placeholder')"
             :value="catalogNumbersValue" @blur="changeCatalogNumbersQuery($event)" @keyup.enter="loseFocus($event)">
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { ARTWORKS_FILTERS } from '../../consts';

  export default {
    name: 'CatalogNumbersSearch',
    data() {
      return {
        path: ARTWORKS_FILTERS.CATALOG_NUMBERS.PATH,
      };
    },
    computed: {
      ...mapGetters(['filterValue']),
      catalogNumbersValue() {
        return this.filterValue(this.path);
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenCatalogNumbersAreChanging']),
      changeCatalogNumbersQuery(event) {
        this.getArtworksWhenCatalogNumbersAreChanging(
          { path: this.path, value: event.target.value },
        );
      },
      loseFocus(event) {
        event.target.blur(event);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/catalog_numbers_search.vue?3828a476